import { css as _css } from "@emotion/core";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@domain-group/fe-co-icon/lib/js/tick';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { Checkbox } from '@domain-group/fe-co-form-elements';
import isEqual from 'lodash/isEqual';
import toLower from 'lodash/toLower';
import * as styles from './allhomes-create-property-alert.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FREQ_OPTIONS = ['Instantly', 'Daily', 'Weekly', 'Never'];
class CreatePropertyAlert extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onCreateAlert", () => {
      this.props.onCreateAlert({
        selectedOption: this.state.selectedOption
      });
    });
    this.state = {
      selectedOption: props.selectedOption
    };
  }
  render() {
    var onCancel = this.props.onCancel;
    return ___EmotionJSX("div", this.props, ___EmotionJSX("div", {
      css: styles.message
    }, this.props.message), ___EmotionJSX("div", null, FREQ_OPTIONS.map(option => ___EmotionJSX("button", {
      type: "button",
      key: option,
      css: styles.option,
      onClick: () => {
        this.setState({
          selectedOption: option
        });
      }
    }, option, ' ', isEqual(toLower(this.state.selectedOption), toLower(option)) && ___EmotionJSX(CheckIcon, {
      css: styles.selectedOptionIcon
    }))), false && ___EmotionJSX(Checkbox, {
      type: "checkbox",
      css: styles.alwaysCheck,
      value: "always",
      checked: this.props.isAlways,
      labelContent: "This is how I'll always want it",
      appearance: "full-width"
    })), ___EmotionJSX("div", {
      css: styles.buttonGroup
    }, ___EmotionJSX(Button, {
      appearance: "secondaryNeutral",
      css: /*#__PURE__*/_css([styles.button, styles.lightButton]),
      onClick: onCancel
    }, "Cancel"), ___EmotionJSX(Button, {
      appearance: "accent",
      css: styles.button,
      onClick: this.onCreateAlert
    }, this.props.createButtonLabel)));
  }
}
CreatePropertyAlert.propTypes = {
  onCancel: PropTypes.func,
  onCreateAlert: PropTypes.func,
  selectedOption: PropTypes.string,
  message: PropTypes.string.isRequired,
  createButtonLabel: PropTypes.string,
  isAlways: PropTypes.bool
};
CreatePropertyAlert.defaultProps = {
  onCancel: () => {},
  onCreateAlert: () => {},
  selectedOption: null,
  createButtonLabel: 'Ok',
  isAlways: false
};
export default CreatePropertyAlert;